import videojs from 'video.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;
const Plugin = videojs.getPlugin('plugin'); // Получить родительский класс плагина

class RotateScreenPlugin extends Plugin { // Создать дочерний класс от Plugin
  constructor(player, options) {

    super(player, options);

    player.on('fullscreenchange', function() {
      if (!screen.orientation || !screen.orientation.lock || !screen.orientation.unlock) return;
      if (player.isFullscreen()) {
        screen.orientation.lock("landscape");
      } else {
        screen.orientation.unlock();
      }
    });
  }
}

registerPlugin('rotateScreenPlugin', RotateScreenPlugin); // Зарегистрировать плагин в VideoJS
